import React from 'react';

interface MaintenanceScreenProps {
  text: string;
}

const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({ text }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f6fa',
        color: '#223366',
        padding: 32,
        textAlign: 'center',
      }}
    >
      <img
        src="/favicon.ico"
        alt="Logo"
        style={{ width: 80, marginBottom: 32 }}
      />
      <h1 style={{ fontSize: 32, marginBottom: 24 }}>Sitio en mantenimiento</h1>
      <div
        style={{
          fontSize: 20,
          maxWidth: 600,
          margin: '0 auto',
          whiteSpace: 'pre-line',
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default MaintenanceScreen;
